import {
    NinchatActionType,
    NinchatBeginSsoAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatSsoBegunEvent} from '../types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const beginSso = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatBeginSsoAction}`,
    async (arg: NinchatActionParams<NinchatBeginSsoAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatBeginSsoAction

        try {
            return await ninchatClient.call(params) as NinchatSsoBegunEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
